import React from "react";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { ButtonGrid } from "@sonder/ui/source/styled/fragments/ButtonGrid";
import { useGetTaskContextsQuery } from "core/queries/GetTaskContexts";
import { ButtonGridMultiContentLoader } from "tasks/components/ButtonGrid.loader";
import { TaskContextSubjectTypeEnum, TypeEnum } from "typings/globalGQLTypes";

export interface SerializedTaskContextFeatures {
  defaultValue: string;
  mutable: boolean;
  name: string;
  required: boolean;
}

export interface SerializedTreeStructureTaskContext {
  children: SerializedTreeStructureTaskContext[];
  contextFeatures: SerializedTaskContextFeatures[];
  contextItemFeatures: SerializedTaskContextFeatures[];
  contextItemDisplayName: string;
  contextItemName: string;
  contextItemNameLocalized: string;
  contextId: string;
  contextName: string;
}

interface TaskContextsProps {
  categoryId?: string;
  locationId?: string;
  onChange?: (context: SerializedTreeStructureTaskContext) => void;
  subjectType: TaskContextSubjectTypeEnum;
  taskContextNodes?: SerializedTreeStructureTaskContext[];
  taskType: TypeEnum;
}

export const TaskContexts = ({
  categoryId,
  locationId,
  onChange,
  subjectType,
  taskContextNodes,
  taskType,
}: TaskContextsProps) => {
  const { loading, data, error } = useGetTaskContextsQuery({
    skip: !categoryId || !locationId,
    variables: {
      filters: {
        categoryIds: categoryId ? [categoryId] : [],
        locationIds: locationId ? [locationId] : [],
        taskTypes: taskType ? [taskType] : [],
        subjectTypes: subjectType ? [subjectType] : [],
      },
    },
  });

  if (!categoryId || !locationId) {
    return null;
  }

  const nodes =
    taskContextNodes ||
    (data?.taskContextConnections?.serializedTreeStructuredTaskContexts &&
      JSON.parse(
        data?.taskContextConnections?.serializedTreeStructuredTaskContexts,
      ));
  return (
    <>
      {loading && <ButtonGridMultiContentLoader />}
      {error && error.message && `There was an error: ${error.message}.`}
      {nodes && (
        <ButtonGrid>
          {nodes.map((node: SerializedTreeStructureTaskContext) => (
            <Button
              key={node?.contextItemName}
              onClick={() => {
                if (onChange) {
                  onChange(node);
                }
              }}
            >
              {node?.contextItemNameLocalized}
            </Button>
          ))}
        </ButtonGrid>
      )}
    </>
  );
};
